import React from "react";
import "../css/Footer6.css";

const Footer6 = () => {
  return (
    <footer className="footer6">

      {/* TOP GRID */}
      <div className="f6-grid">

        {/* BRAND */}
        <div className="f6-brand">
          <h2>GRIT</h2>
          <p>
            Urban performance training built for discipline, consistency,
            and long-term strength.
          </p>
        </div>

        {/* LINKS */}
        <div className="f6-links">
          <h4>Explore</h4>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/workouts">Workouts</a>
          <a href="/services">Services</a>
          <a href="/plans">Plans</a>
        </div>

        <div className="f6-links">
          <h4>Studio</h4>
          <a href="/gallery">Gallery</a>
          <a href="/trainers">Trainers</a>
          <a href="/faqs">FAQs</a>
          <a href="/contact">Contact</a>
        </div>

        {/* INFO */}
        <div className="f6-info">
          <h4>Location</h4>
          <p>
            214 Industrial Ave<br />
            Brooklyn, NY 11222
          </p>

          <p className="f6-meta">
            Open Daily<br />
            6:00 AM – 10:00 PM
          </p>
        </div>

      </div>


      {/* DIVIDER */}
      <div className="f6-divider"></div>


      {/* BOTTOM BAR */}
      <div className="f6-bottom">
        <span>© {new Date().getFullYear()} GRIT TRAINING LAB</span>

        <div className="f6-socials">
          <a href="#">IG</a>
          <a href="#">FB</a>
          <a href="#">YT</a>
        </div>
      </div>

    </footer>
  );
};

export default Footer6;
